module.exports = __webpack_public_path__ + "img/24d4ca9.png";